export default {"src":"/_next/static/media/iconLight.399f03f2.svg","height":48,"width":48};